import React, { useState, useEffect, useContext } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	TextField,
	Grid,
	Paper,
	Select,
	CircularProgress,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import UseStyles from "./UseStyles";
import MenuItem from "@material-ui/core/MenuItem";
import GoogleMap from "../../GmapAutoComplete/GoogleMap";
import moment from "moment";
import {
	Address2Types,
	States,
	titleResponsibility,
	YesNo,
} from "../Data/constants";
import Cleave from "cleave.js/react";
import AlertPopUP from "../../AlertBox/AlertPopUp";
import SummaryContext from "./SummaryContext";
import Utils from "../../Utils";
import { gridColumnGroupsLookupSelector } from "@mui/x-data-grid";

import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";

/* API */
import { DocsDataAPI } from "../../../../common/lib/API/DocsDataAPI";

const theme = createTheme({
	overrides: {
		MuiOutlinedInput: {
			root: {
				borderRadius: 0,
				fontSize: "0.8rem",
				padding: "0px",
			},
			input: {
				padding: "8px",
			},
		},
	},
});

const ApplicantEdit = ({
	ApplicantData,
	currentSalesRep,
	setCurrentSalesRep,
}) => {
	const classes = UseStyles();
	const {
		alertModal,
		application,
		invoiceAmountChange,
		handleChange,
		updateApplication,
		assetType,
		setApplication,
		appTotalData,
	} = useContext(SummaryContext);

	const [isValidEmail, setIsValidEmail] = useState(true);

	const [salesReps, setSalesReps] = useState([]);

	const [selectedSalesRep, setSelectedSalesRep] = useState("");
	const [selectedSalesRepID, setSelectedSalesRepID] = useState("");
	const [selectedSalesRepName, setSelectedSalesRepName] = useState("");

	const [showCustomItemDialog, setShowCustomItemDialog] = React.useState(false);
	const [customSalesRepFirstName, setCustomSalesRepFirstName] = useState("");
	const [customSalesRepLastName, setCustomSalesRepLastName] = useState("");
	const [customSalesRepEmail, setCustomSalesRepEmail] = useState("");
	const [customSalesRepPhone, setCustomSalesRepPhone] = useState("");
	const [isAddingSalesRep, setIsAddingSalesRep] = useState(false);

	const [brokerAgencyID, setBrokerAgencyID] = useState("");

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		try {
			setSelectedSalesRep(currentSalesRep);
			setSalesReps(appTotalData.broker.agency_persons);

			let brokerAgencyID = await DocsDataAPI.fetchBrokerAgencyID(
				application.broker_id
			);
			setBrokerAgencyID(brokerAgencyID.referral_agency_id);
		} catch (error) {
			console.error("Error fetching funding checklist response:", error);
		}
	};

	const handleSalesRepChange = (selectedItem) => {
		setSelectedSalesRep(`${selectedItem.name} (${selectedItem.email})`);
		setSelectedSalesRepName(selectedItem.name);
		setSelectedSalesRepID(selectedItem.id);
	};

	const handleCreateCustomSalesRep = async () => {
		setIsAddingSalesRep(true);

		await DocsDataAPI.createAgencyPerson({
			email: customSalesRepEmail,
			first_name: customSalesRepFirstName,
			last_name: customSalesRepLastName,
			phone: customSalesRepPhone,
			referral_agency_id: brokerAgencyID,
		}).catch((error) => {
			console.log(`Create Agency: ${error.data.statusMessage}`);
		});

		updateData();
	};

	function checkValidEmail(val) {
		let regEmail = /.+@.+/;
		if (val && val !== undefined && !regEmail.test(val)) {
			setIsValidEmail(false);
			return false;
		} else {
			setIsValidEmail(true);
			return true;
		}
	}

	const updateData = () => {
		//remove delimiters
		let SSN = application?.FEIN;
		SSN = SSN.replace(/-/g, "");
		let newApplication = {
			...application,
			FEIN: SSN
		};
		if (selectedSalesRepID && selectedSalesRepName) {
			newApplication = {
				...newApplication,
				sales_rep_id: selectedSalesRepID,
				sales_rep_name: selectedSalesRepName,
			};
		}
		const isValid = checkValidEmail(application.Email);
		if (isValid) updateApplication(newApplication, appTotalData.locked_by_email);
	};


	const updateMapInfo = (mapInfo) => {
		if (mapInfo.city && mapInfo.streetNumber) {
			setApplication({
				...application,
				["Street_Address"]: `${mapInfo.streetNumber} ${mapInfo.street}`,
				["City"]: mapInfo.city,
				["ZipCode"]: mapInfo.zipCode,
				["State"]: mapInfo.state,
			});
		}
	};

	return (
		<>
			<Dialog
				open={showCustomItemDialog}
				onClose={(event, reason) => {
					if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
						setShowCustomItemDialog(false);
					}
				}}
				aria-labelledby="form-dialog-title"
				fullWidth={true}
				maxWidth={"xs"}>
				<DialogTitle id="form-dialog-title">Add Sales Rep</DialogTitle>
				<DialogContent>
					<Grid container direction="row" alignItems="center" spacing={2}>
						<Grid item xs={3}>
							<Typography>First Name *</Typography>
						</Grid>
						<Grid item xs={9}>
							<ThemeProvider theme={theme}>
								<TextField
									className={classes.customItemTextField}
									variant="outlined"
									fullWidth
									value={customSalesRepFirstName}
									onChange={(event) => setCustomSalesRepFirstName(event.target.value)}
								/>
							</ThemeProvider>
						</Grid>
						<Grid item xs={3}>
							<Typography>Last Name *</Typography>
						</Grid>
						<Grid item xs={9}>
							<ThemeProvider theme={theme}>
								<TextField
									className={classes.customItemTextField}
									variant="outlined"
									fullWidth
									value={customSalesRepLastName}
									onChange={(event) => setCustomSalesRepLastName(event.target.value)}
								/>
							</ThemeProvider>
						</Grid>
						<Grid item xs={3}>
							<Typography>Email *</Typography>
						</Grid>
						<Grid item xs={9}>
							<ThemeProvider theme={theme}>
								<TextField
									className={classes.customItemTextField}
									variant="outlined"
									fullWidth
									value={customSalesRepEmail}
									onChange={(event) => setCustomSalesRepEmail(event.target.value)}
								/>
							</ThemeProvider>
						</Grid>
						<Grid item xs={3}>
							<Typography>Phone</Typography>
						</Grid>
						<Grid item xs={9}>
							<ThemeProvider theme={theme}>
								<TextField
									className={classes.customItemTextField}
									variant="outlined"
									fullWidth
									value={customSalesRepPhone}
									onChange={(event) => setCustomSalesRepPhone(event.target.value)}
								/>
							</ThemeProvider>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions style={{ margin: "30px 25px 20px 10px", padding: "0px" }}>
					<Button
						onClick={() => setShowCustomItemDialog(false)}
						color="primary"
						style={{ width: "120px" }}>
						Cancel
					</Button>
					<Button
						onClick={handleCreateCustomSalesRep}
						disabled={
							customSalesRepFirstName.length <= 0 ||
							customSalesRepLastName.length <= 0 ||
							customSalesRepEmail.length <= 0 ||
							isAddingSalesRep
						}
						style={{ width: "120px" }}
						color="primary">
						Add
						{isAddingSalesRep && (
							<CircularProgress
								size={25}
								style={{ marginLeft: "15px" }}
								color="secondary"
							/>
						)}
					</Button>
				</DialogActions>
			</Dialog>
			<form noValidate autoComplete="off">
				<TableContainer component={Paper}>
					<Table className={classes.table} aria-label="simple table">
						<TableBody>
							<TableRow className={classes.row_color1}>
								<TableCell
									className={classes.cell_header_bold}
									style={{ width: "15%" }}
									align="right">
									Broker Name
								</TableCell>
								<TableCell style={{ width: "34%" }} align="left">
									{application.Broker_Name}
								</TableCell>
								{currentSalesRep && <>
									<TableCell
										className={classes.cell_header_bold}
										style={{ width: "16%" }}
										align="right">
										Sales Rep
									</TableCell>
									<TableCell style={{ width: "35%" }} align="left">
										<Select
											variant="filled"
											value={selectedSalesRep || ""}
											style={{
												width: "80%",
												marginTop: "3px",
												marginLeft: "3px",
											}}
											inputProps={{
												className: classes.textBoxDesign,
											}}
											name="sales_rep"
											id="sales_rep"
										//onChange={(event) => handleSalesRepChange(event)}
										>
											{salesReps.map((item, i) => (
												<MenuItem
													key={i}
													onClick={() => handleSalesRepChange(item)}
													data-index={i}
													value={`${item.name} (${item.email})`}>
													{`${item.name} (${item.email})`}
												</MenuItem>
											))}
										</Select>
										<IconButton
											color="secondary"
											aria-label="upload picture"
											component="span"
											onClick={() => setShowCustomItemDialog(true)}>
											<AddIcon
												className={classes.applicantIcon}
												style={{
													backgroundColor: "#303F9F",
													color: "white",
												}}
											/>
										</IconButton>
									</TableCell>
								</>}
							</TableRow>
							<TableRow className={classes.row_color2}>
								<TableCell className={classes.cell_header_bold} align="right">
									Contract Number
								</TableCell>
								<TableCell align="left">{application.Contract_Number}</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									Account Manager
								</TableCell>
								<TableCell align="left">{application.Account_Manager}</TableCell>
							</TableRow>
							<TableRow className={classes.row_color1}>
								<TableCell className={classes.cell_header_bold} align="right">
									Referral Party Id
								</TableCell>
								<TableCell align="left">{application.Referral_Party_Id}</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									Invoice Amount
								</TableCell>
								<TableCell align="left">
									$
									{application.invoice_amount
										? Utils.formatCurrencyNumber(application.invoice_amount)
										: "0.0"}
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color2}>
								<TableCell className={classes.cell_header_bold} align="right">
									SSN/FEIN
								</TableCell>
								<TableCell align="left">
									<div className={classes.cleaveInput}>
										<Cleave
											value={application?.FEIN}
											placeholder="Enter phone number"
											options={{
												delimiters: ["-", "-"],
												numericOnly: true,
												uppercase: true,
												blocks: [3, 2, 4],
											}}
											name="FEIN"
											id="FEIN"
											max="9"
											onChange={handleChange}
										/>
									</div>
									{/* <TextField
									fullWidth={true}
									placeholder="Enter SSN/FEIN"
									InputLabelProps={{
										shrink: true,
									}}
									type="number"
									variant="filled"
									name="FEIN"
									id="FEIN"
									value={application?.FEIN}
									onChange={handleChange}
									inputProps={{
										className: classes.textBoxDesign,
									}}
								/> */}
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									DBA
								</TableCell>
								<TableCell align="left">
									<TextField
										fullWidth={true}
										placeholder="Enter DBA"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										value={application.DBA === "None" ? "" : application.DBA}
										name="DBA"
										id="DBA"
										onChange={handleChange}
										inputProps={{
											className: classes.textBoxDesign,
										}}
									/>
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color1}>
								<TableCell className={classes.cell_header_bold} align="right">
									Name
								</TableCell>
								<TableCell align="left">
									<TextField
										fullWidth={true}
										placeholder="Enter name"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										value={application.Name}
										name="Name"
										id="Name"
										onChange={handleChange}
									/>
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									Search Address
								</TableCell>
								<TableCell align="left">
									<GoogleMap
										fullWidth={true}
										name="Search Address"
										id={"map-address-1"}
										className="gps_address_input"
										placeholder="Search address"
										updateMapInfo={updateMapInfo}
									/>
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color2}>
								<TableCell className={classes.cell_header_bold} align="right">
									Business Start Date
								</TableCell>
								<TableCell align="left">
									{moment(application.Business_Start_Date).format("MM/DD/YYYY")}
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									Street Address
								</TableCell>
								<TableCell align="left">
									<TextField
										placeholder="Enter street address "
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										style={{ width: "70%" }}
										value={application.Street_Address}
										name="Street_Address"
										id="Street_Address"
										onChange={handleChange}
										inputProps={{
											className: classes.textBoxDesign,
										}}
									/>
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color1}>
								<TableCell className={classes.cell_header_bold} align="right">
									Industry Experience
								</TableCell>
								<TableCell align="left">
									{moment(application.Industry_Experience).format("MM/DD/YYYY")}
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									Street Address Line 2
								</TableCell>
								<TableCell align="left">
									<Select
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										value={application.address2Type || ""}
										style={{
											width: "25%",
											marginTop: "3px",
											marginLeft: "3px",
										}}
										name="address2Type"
										id="address2Type"
										onChange={handleChange}>
										{Address2Types &&
											Address2Types.map((item, i) => (
												<MenuItem key={i} value={item.value}>
													{item.label}
												</MenuItem>
											))}
									</Select>
									&nbsp;
									<TextField
										placeholder="Enter street address line 2"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										style={{ width: "70%" }}
										value={application.Street_Address_Line_2}
										name="Street_Address_Line_2"
										id="Street_Address_Line_2"
										onChange={handleChange}
										inputProps={{
											className: classes.textBoxDesign,
										}}
									/>
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color2}>
								<TableCell className={classes.cell_header_bold} align="right">
									Phone
								</TableCell>
								<TableCell align="left">
									<div className={classes.cleaveInput}>
										<Cleave
											value={application.Phone}
											placeholder="Enter phone number"
											options={{
												numericOnly: true,
												blocks: [0, 3, 3, 4],
												delimiters: ["(", ") ", "-", " x"],
												delimiterLazyShow: true,
											}}
											name="Phone"
											id="Phone"
											onChange={handleChange}
										/>
									</div>
									{/* <TextField
                    fullWidth={true}
                    placeholder="Enter state"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="filled"
                    value={application.Phone}
                    name="Phone"
                    id="Phone"
                    onChange={handleChange}
                    inputProps={{
                      className: classes.textBoxDesign,
                    }}
                  /> */}
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									City/State/Zipcode
								</TableCell>
								<TableCell align="left">
									<TextField
										placeholder="Enter city"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										style={{ width: "35%" }}
										inputProps={{
											className: classes.textBoxDesign,
										}}
										value={application.City}
										name="City"
										id="City"
										onChange={handleChange}
									/>
									&nbsp;&nbsp;
									<Select
										placeholder="Enter state"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										value={application.State || ""}
										style={{ width: "30%", marginTop: "3px" }}
										inputProps={{
											className: classes.textBoxDesign,
										}}
										name="State"
										id="State"
										onChange={handleChange}>
										{States &&
											States.map((item, i) => (
												<MenuItem key={i} value={item.label}>
													{item.label}
												</MenuItem>
											))}
									</Select>
									&nbsp;&nbsp;&nbsp;
									<TextField
										placeholder="Enter state"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										style={{ width: "25%" }}
										inputProps={{
											className: classes.textBoxDesign,
										}}
										value={application.ZipCode}
										name="ZipCode"
										id="ZipCode"
										onChange={handleChange}
									/>
									&nbsp;&nbsp;
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color1}>
								<TableCell className={classes.cell_header_bold} align="right">
									Mobile
								</TableCell>
								<TableCell align="left">
									<div className={classes.cleaveInput}>
										<Cleave
											value={application.Mobile}
											placeholder="Enter mobile number"
											options={{
												blocks: [0, 3, 3, 4],
												delimiters: ["(", ") ", "-", " x"],
												delimiterLazyShow: true,
											}}
											name="Mobile"
											id="Mobile"
											onChange={handleChange}
										/>
									</div>
									{/* <TextField
                    size="small"
                    style={{ width: "100%" }}
                    inputProps={{
                      className: classes.textBoxDesign,
                    }}
                    variant="outlined"
                    value={application.Mobile}
                    name="Mobile"
                    id="Mobile"
                    onChange={handleChange}
                  /> */}
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									Fax
								</TableCell>

								<TableCell align="left">
									<div className={classes.cleaveInput}>
										<Cleave
											value={application.FAX}
											placeholder="Enter fax"
											options={{
												numericOnly: true,
												blocks: [0, 3, 3, 4],
												delimiters: ["(", ") ", "-", " x"],
												delimiterLazyShow: true,
											}}
											name="FAX"
											id="FAX"
											onChange={handleChange}
										/>
									</div>

									{/* <TextField
                    size="small"
                    style={{ width: "100%" }}
                    inputProps={{
                      className: classes.textBoxDesign,
                    }}
                    variant="outlined"
                    value={application.FAX}
                    name="FAX"
                    id="FAX"
                    onChange={handleChange}
                  /> */}
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color2}>
								<TableCell className={classes.cell_header_bold} align="right">
									CDL Number
								</TableCell>
								<TableCell align="left">
									<TextField
										fullWidth={true}
										placeholder="Enter CDL number"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										value={application.CDL_Number}
										name="CDL_Number"
										id="CDL_Number"
										onChange={handleChange}
									/>
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									Email
								</TableCell>
								<TableCell align="left">
									<TextField
										fullWidth={true}
										placeholder="Enter email"
										InputLabelProps={{
											shrink: true,
										}}
										error={!isValidEmail}
										helperText={!isValidEmail && "Email is not valid"}
										variant="filled"
										type="email"
										value={application.Email}
										name="Email"
										id="Email"
										onChange={handleChange}
									/>
								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color1}>
								<TableCell className={classes.cell_header_bold} align="right">
									Is Discounted
								</TableCell>
								<TableCell align="left">
									<Select
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										value={application.Is_Discounted || ""}
										style={{
											width: "40%",
											marginTop: "3px",
											marginLeft: "3px",
										}}
										inputProps={{
											className: classes.textBoxDesign,
										}}
										name="Is_Discounted"
										id="Is_Discounted"
										onChange={handleChange}>
										{YesNo &&
											YesNo.map((item, i) => (
												<MenuItem key={i} value={item.value}>
													{item.label}
												</MenuItem>
											))}
									</Select>
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									CDL Expiration Date
								</TableCell>
								<TableCell align="left">
									<TextField
										fullWidth={true}
										placeholder="Enter CDL expiration date"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										type="date"
										value={application.CDL_Expiration_Date}
										name="CDL_Expiration_Date"
										id="CDL_Expiration_Date"
										onChange={handleChange}
									/>
								</TableCell>
								<TableCell
									className={classes.cell_header_bold}
									align="right"></TableCell>
							</TableRow>
							{application?.status !== "Funding" && assetType !== "Non-Titled" && (
								<TableRow className={classes.row_color1}>
									<TableCell className={classes.cell_header_bold} align="right">
										Title Responsibility
									</TableCell>
									<TableCell align="left">
										<Select
											// disabled={application?.status !== "Funding"}
											fullWidth={true}
											InputLabelProps={{
												shrink: true,
											}}
											variant="filled"
											value={application.title_responsibility || ""}
											style={{ marginTop: "3px", marginLeft: "3px" }}
											inputProps={{
												className: classes.textBoxDesign,
											}}
											name="title_responsibility"
											id="title_responsibility"
											onChange={handleChange}>
											{titleResponsibility &&
												titleResponsibility.map((item, i) => (
													<MenuItem key={i} value={item.label}>
														{item.label}
													</MenuItem>
												))}
										</Select>
									</TableCell>
									<TableCell className={classes.cell_header_bold} align="right">
										State to be titled in
									</TableCell>
									<TableCell align="left">
										{assetType !== "Non-Titled" && (
											<Select
												// disabled={application?.status !== "Funding"}
												fullWidth={true}
												InputLabelProps={{
													shrink: true,
												}}
												variant="filled"
												value={application.state_of_title || ""}
												style={{ marginTop: "3px", marginLeft: "3px" }}
												inputProps={{
													className: classes.textBoxDesign,
												}}
												name="state_of_title"
												id="state_of_title"
												onChange={handleChange}>
												{States &&
													States.map((item, i) => (
														<MenuItem key={i} value={item.label}>
															{item.label}
														</MenuItem>
													))}
											</Select>
										)}
									</TableCell>
								</TableRow>
							)}
							<TableRow className={classes.row_color2}>
								<TableCell className={classes.cell_header_bold} align="right">
									MC Number
								</TableCell>
								<TableCell align="left">
									<TextField
										fullWidth={true}
										placeholder="Enter MC Number"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
										value={application.sales_tax_exemption_number}
										name="sales_tax_exemption_number"
										id="sales_tax_exemption_number"
										onChange={handleChange}
									/>
								</TableCell>
								<TableCell className={classes.cell_header_bold} align="right">
									{" "}
								</TableCell>
								<TableCell align="left">

								</TableCell>
							</TableRow>
							<TableRow className={classes.row_color2}>
								<TableCell align="right" colSpan="4">
									<Button
										variant="contained"
										size="medium"
										color="primary"
										className={classes.buttonDesign}
										startIcon={
											alertModal.isSubmitting ? (
												<CircularProgress style={{ color: "white" }} size={20} />
											) : (
												<SaveIcon />
											)
										}
										onClick={() => {
											if (setCurrentSalesRep)
												setCurrentSalesRep(selectedSalesRep);
											updateData();
										}}>
										Update
									</Button>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</form>
		</>
	);
};
export default ApplicantEdit;
